import {Box, Grid, GridItem, Heading, Hr, Text} from '@constellation/core';
import {styled} from 'styled-components';
import {QuoteSummaryButtons} from '../../../../common/Analytics/Tagging/index.js';

export const TransactionChargesDiv = styled(Box)`
  ${(props) => `
  background-color: ${props.theme.color_background_neutral_1};
  border: 2px solid ${props.theme.color_border_default_1};
  padding: 16px;
  @media (max-width: ${props.theme.breakpoint_lg}) {
    padding: 9px 12px;
  }
  a[aria-label]{
    text-decoration: none;
    color: ${props.theme.color_text_default_2};
    span {
      font-size: .79rem;
    }
    &:hover {
      text-decoration: underline;
    }
  }
`}
`;
export const TransactionFeeLabel = styled(Text)`
  ${(props) => `
  display: inline-block;
  width: 13.25rem;
  border: 1px dashed ${props.theme.color_border_default_1};
  padding: 2px 8px;
  margin-bottom: 14px;
  @media (max-width: ${props.theme.breakpoint_lg}) {
    width: calc(100% - 127px);
    margin-left: 15px;
  }
  @media screen and (min-width:1025px) and (max-width: 1094px) {
    width: 11.11rem;
  }
`}
`;
export const TransactionFeeValue = styled(Text)`
  ${(props) => `
  display: inline-block;
  width: 5.8rem;
  border: 1px dashed ${props.theme.color_border_default_1};
  border-left: 0px;
  margin-right: 16px;
  padding: 2px 0px;
  background-color: ${props.theme.color_background_neutral_2};
  text-align: center;
  font-weight: 700;
  @media (max-width: ${props.theme.breakpoint_lg}) {
    margin-right: 0px;
  }
`}
`;
export const TransactionHeading = styled(Text)`
  ${(props) => `
  display: inline-block;
  margin-right: 24px;
  @media (max-width: ${props.theme.breakpoint_lg}) {
    padding-left: 15px;
  }
`}
`;
export const AuthorisationGrid = styled(Grid)`
  margin-left: 0px;
`;
export const AuthorisationFeeLabel = styled(Text)`
  ${(props) => `
  display: inline-block;
  width: calc(100% - 132px);
  border: 1px solid ${props.theme.color_border_default_1};
  padding: 2px 8px;
  @media (max-width: ${props.theme.breakpoint_lg}) {
    width: calc(100% - 112px);
  }
`}
`;
export const AuthorisationFeeValue = styled(Text)`
  display: inline-block;
  width: 5.8rem;
  border: 1px solid ${(props) => props.theme.color_border_default_1};
  border-left: 0px;
  padding: 2px 0px;
  background-color: ${(props) => props.theme.color_background_neutral_2};
  text-align: center;
  font-weight: 700;
`;
export const GridItemHeadingLine = styled(Hr)`
  border-top: 1px solid ${(props) => props.theme.color_border_default_1};
`;
export const SmallLineUp = styled.div`
  width: 12px;
  border-top: 1px solid;
  position: relative;
  left: -12px;
`;
export const SmallLineDown = styled.div`
  width: 12px;
  border-top: 1px solid;
  position: relative;
  top: 12px;
  left: -12px;
`;
export const GridItemEven = styled(GridItem)`
  background-color: ${(props) => props.theme.color_background_page_2};
  text-align: center;
  padding: 4px 0px;
`;
export const AdditionalChargesLine = styled.div`
  width: 12px;
  height: 76%;
  margin-top: 28px;
  border: 1px solid;
  border-left: 0px;
  position: relative;
  left: calc(100% - 28px);
`;
export const AdditionalChargesHorizontalLine = styled.div`
  width: calc(100% + 1rem);
  margin-left: -1rem;
  margin-top: 34px;
  border-top: 1px solid;
`;
export const AdditionalChargesGridItem = styled(GridItem)`
  height: inherit;
  padding: 0px;
`;
export const AdditionalChargesGrid = styled(Grid)`
  height: 100%;
`;
export const GridItemNoPadding = styled(GridItem)`
  padding: 0px;
`;
export const GridItemNoPaddingLeft = styled(GridItem)`
  padding-left: 0px;
`;
export const OtherSectionHeading = styled(Heading)`
  ${(props) => `
  @media (max-width: ${props.theme.breakpoint_lg}) {
    margin-left: 0px;
  }
`}
`;
export const OtherSectionDiv = styled(Box)`
  padding: 0px;
`;
export const DetailsGrid = styled(Grid)`
  background-color: ${(props) => props.theme.color_background_page_2};
  padding: 6px 0px;
  margin: 0px;
`;
export const OtherSectionValues = styled(GridItem)`
  text-align: right;
  padding-left: 0px;
`;
export const OtherSectionText = styled(Text)`
  ${(props) => `
  @media (max-width: ${props.theme.breakpoint_md}) {
    font-size: 1rem;
  }
  a[aria-label]{
    text-decoration: none;
    color: ${props.theme.color_text_default_2};
    span {
      font-size: .79rem;
    }
    &:hover {
      text-decoration: underline;
    }
  }
  }
`}
`;
export const MonthlyGridEven = styled(Grid)`
  background-color: ${(props) => props.theme.color_background_page_2};
  padding: 6px 4px;
  margin: 0px;
`;
export const MonthlyGridServiceFee = styled(Grid)`
  background-color: #fafafa;
  padding: 6px 4px;
  margin: 0px;
`;
export const MonthlyGridPOS = styled(Grid)`
  padding: 6px 4px;
  margin: 0px;
`;
export const ExampleDiv = styled(Box)`
  ${(props) => `
  background-color: #f9f9f9;
  padding: 12px 16px;
  @media (max-width: ${props.theme.breakpoint_md}) {
    padding: 0px;
    background-color: transparent;
  }
`}
`;
export const ExampleGrid = styled(Grid)`
  margin-right: 0px;
`;
export const ExampleGridItem = styled(GridItem)`
  text-align: center;
  padding: 4px 0px;
`;
export const ExampleLargeLine = styled(Hr)`
  ${(props) => `
  border-top: 1px solid ${props.theme.color_border_default_1};
  @media (max-width: ${props.theme.breakpoint_md}) {
    display: none;
  }
  @media (width: ${props.theme.breakpoint_md}) {
    display: block;
  }
`}
`;
export const ExampleSmallLine = styled(Hr)`
  ${(props) => `
  border-top: 1px solid ${props.theme.color_border_default_1};
  margin-top: 12px;
  @media (min-width: ${props.theme.breakpoint_md}) {
    display: none;
  }
`}
`;
export const ExampleGridItemHeading = styled(GridItem)`
  ${(props) => `
  padding: 4px 0.75rem;
  @media (max-width: ${props.theme.breakpoint_md}) {
    padding: 4px 0px 0px 0.75rem;
  }
`}
`;
export const ExampleValuesGrid = styled(Grid)`
  height: 100%;
  ${(props) => `
  @media (max-width: ${props.theme.breakpoint_md}) {
    margin-left: 0px;
  }
`}
`;
export const ExampleGridMarginBottom = styled(GridItem)`
  ${(props) => `
  @media (max-width: ${props.theme.breakpoint_md}) {
    margin-bottom: 0.75rem;
  }
  @media (width: ${props.theme.breakpoint_md}) {
    margin-bottom: 0px;
  }
`}
`;
export const ExampleRowOneText = styled(Text)`
  ${(props) => `
  @media (min-width: ${props.theme.breakpoint_lg}) {
    display: inline-block;
    width: 75%;
  }
  @media (max-width: ${props.theme.breakpoint_md}) {
    font-size: 1rem;
  }
`}
`;
export const ExampleRowTwoText = styled(Text)`
  ${(props) => `
  @media (min-width: ${props.theme.breakpoint_lg}) {
    display: inline-block;
    width: 92%;
  }
  @media (max-width: ${props.theme.breakpoint_md}) {
    font-size: 1rem;
  }
`}
`;
export const FootnotesDiv = styled.div`
  display: flex;
`;
export const FootnotesListItemNo = styled.div`
  ${(props) => `
  width: 2%;
  margin-right: 0.4rem;
  text-align: right;
  @media (max-width: ${props.theme.breakpoint_lg}) {
    width: 5.5%
  }
  `}
`;
export const FootnotesListItem = styled(Text)`
  width: calc(100% - 42px);
  span {
    a {
      position: absolute;
      transform: translateY(-60000%);
      transition: transform 0.3s;
      &:focus {
        position relative;
        transform: translateY(0%);
      }
    }
  }
`;
export const CallToActionWrapper = styled(Box)`
  ${(props) => `
  border: 1px solid ${props.theme.color_border_default_1};
  padding: 24px;
  @media (max-width: ${props.theme.breakpoint_md}) {
  margin-top:20px;
  margin-bottom:20px;
  .csl-list {
    margin-bottom:16px
  }
  }
`}
`;
export const ClockWrapper = styled.div`
  ${(props) => `
  display:flex;
  align-items: center;
  @media (max-width: ${props.theme.breakpoint_md}) {
    margin-top:16px;
  }
`}
`;
export const DownloadButton = styled(QuoteSummaryButtons)`
  margin-top: 24px;
  .csl-text-s2 {
    padding-left: 6px;
  }
  .csl-icon {
    width: 18px;
  }
`;
export const FullWidthLine = styled(Hr)`
  width: calc(100% + 2px);
`;
export const TransactionTable = styled.table`
  width: 100%;
  border-collapse: collapse;
`;
export const TableHeadOdd = styled.th`
  background-color: #f9f9f9;
`;
export const TableHeadAligned = styled.th`
  vertical-align: bottom;
  text-align: left;
`;
export const TableCellHeading = styled.th`
  text-align: left;
`;
export const TableHeadEven = styled.th`
  background-color: ${(props) => props.theme.color_background_page_2};
`;
export const TableCellOdd = styled.td`
  background-color: #f9f9f9;
  text-align: center;
`;
export const TableCellEven = styled.td`
  background-color: ${(props) => props.theme.color_background_page_2};
  text-align: center;
`;
export const TableModeCell = styled.td`
  padding-bottom: 4px;
`;
export const TableSpace = styled.span`
  visibility: hidden;
`;
export const TableHeadHideText = styled.th`
  position: absolute;
  left: -999em;
`;
export const TableCellHideText = styled.td`
  position: absolute;
  left: -999em;
`;
export const CardFullWidthLine = styled(Hr)`
  width: calc(100% + 2px);
  margin-top: 5px;
`;
export const TableLabelCell = styled.td`
  padding-top: 3.5px;
`;
